export const actionTypes = {
  TOGGLE_DISPLAY_FAVORITES_ONLY: 'TOGGLE_DISPLAY_FAVORITES_ONLY',
  SORT_VIEW_FACET: 'SORT_VIEW_FACET',
};

export const toggleDisplayFavouritesOnly = () => ({
  type: actionTypes.TOGGLE_DISPLAY_FAVORITES_ONLY,
});
